<template>
  <sc-page title="权限设置" desc="隐藏无需设置权限">
    <div class="auth-rule">
      <a-tree
        v-model:checkedKeys="checkedKeys"
        :treeData="tree"
        :block-node="true"
        :replaceFields="{ key: 'id' }"
        :checkable="true"
      />
    </div>
    <div class="form-btn-group">
      <sc-btn type="primary" :handler="submit" text="保存" />
      <sc-btn style="margin-left: 10px" :handler="reset" text="重置" />
    </div>
  </sc-page>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {request} from '@/util/request';
import _ from 'lodash';
import {message} from 'ant-design-vue';

function getShow(node: any, keys: string[]) {
  if (node.show) {
    keys.push(node.id);
  }
  node.children.map((child: any) => getShow(child, keys));
}

function setShow(node: any, map: Record<string, true>) {
  node.show = !!map[node.id];
  node.children.map((child: any) => setShow(child, map));
}

export default defineComponent({
  name: 'AuthRule',
  data() {
    return {
      origin: [] as any,
      tree: [] as any,
    };
  },
  computed: {
    checkedKeys: {
      get(): string[] {
        const keys: string[] = [];
        this.tree.map((node: any) => getShow(node, keys));
        return keys;
      },
      set(val: any) {
        const map: Record<string, true> = {};
        for (const item of val) {
          map[item] = true;
        }
        this.tree.map((node: any) => setShow(node, map));
      },
    },
  },
  async mounted() {
    this.origin = (await request('develop/auth_rule/index')).authRule;
    this.reset();
  },
  methods: {
    reset() {
      this.tree = _.cloneDeep(this.origin);
    },
    async submit() {
      const res = await request('develop/auth_rule/save', {
        authRule: this.tree,
      });
      if (res) {
        message.success('操作成功');
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.auth-rule {
  padding: $spacing-medium;
  flex-grow: 1;
  overflow: auto;
}

.form-btn-group {
  border-top: 1px solid $color-content-border;
  padding: $spacing-medium;
}
</style>
